<template>
    <div class="h-100">
        <NewEntoCollection v-bind:dialog="newEntoCollectionModal" />

        <h2 class="dispaly-3">Select Template for data entry!</h2>
        <v-divider></v-divider>

        <b-container class="bv-example-row">
            <b-row>
                <b-col cols="12" sm="6">
                    <b-card bg-variant="danger" class="mb-2">
                        <b-card-title>Select a collection code and add counts of Anophs and Culicines.</b-card-title>
                        <b-card-text>
                            Select a collection code and add counts of Anophs and Culicines.
                        </b-card-text>

                        <b-button variant="secondary" @click="updateEntoCollectionModal(true)">Continue</b-button>
                    </b-card>
                </b-col>

                <b-col cols="12" sm="6" v-for="(template) in entoTemplates" :key="template.id">
                    <b-card title="" class="mb-2">
                        <b-card-title>{{template.name}}</b-card-title>
                        <b-card-text>
                            {{template.description || template.name}}
                        </b-card-text>

                        <b-button variant="secondary" @click="selectTemplate(template.id)">Continue</b-button>
                    </b-card>
                </b-col>
            </b-row>
        </b-container>

    </div>
</template>

<script>
    import DashboardBaseTemplate from '@/layouts/DashboardBaseTemplate.vue'

    import {
        mapState,
        mapGetters,
        mapActions
    } from 'vuex';
    import HandleErrors from '@/utilities/handle-errors';

    export default {
        data: function () {
            return {
                // dialog: false
            }
        },
        components: {},
        mixins: [DashboardBaseTemplate],
        computed: {
            ...mapState('websheet', [
                'templates',
                'newEntoCollectionModal'
            ]),
            ...mapGetters('websheet', [
                'entoTemplates'
            ])
        },
        mounted() {
            if (!this.templates.length) {
                this.getTemplates().then(response => {
                    this.setTemplates(response.data);
                }).catch((error) => {
                    HandleErrors.HandleErrors(error);
                });

            }
        },
        methods: {
            ...mapActions('websheet', [
                'getTemplates',
                'setTemplates',
                'updateEntoCollectionModal'
            ]),
            selectTemplate(templateId) {
                this.$router.push({
                    name: 'websheet',
                    params: {
                        templateId: templateId
                    }
                })
            }
        }
    }
</script>

<style>

</style>
